import { SecondaryButton } from 'components/Shared/Button'
import DropDown from 'components/Shared/DropDown'
import Input from 'components/Shared/Input'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDataIntegrations } from './DataIntegrationsProvider'
import { localizeDateObj } from 'utils/helpers'
import ErrorMessage from 'components/Shared/ErrorMessage'
import constants from '../../constants'

export default function AddIntegration() {
  const { t } = useTranslation()
  const { integrationTypes, loading, error, addIntegration } = useDataIntegrations()
  const [selectedIntegration, setSelectedIntegration] = useState({
    type: '',
    secret: '',
    tenantRef: '',
    tenantEndpoint: '',
  })

  const options =
    integrationTypes
      ?.map((type) => ({
        value: type.type,
        text: type.display_name,
      }))
      .sort((a, b) => a.text.localeCompare(b.text)) || []

  const submitIntegration = async () => {
    const name = `${selectedIntegration.type}-${localizeDateObj(new Date(), 'de', 'DD.MM.YYYY.-HH:mm:ss')}`
    const result = await addIntegration({
      serviceName: selectedIntegration.type,
      name: name,
      rawSecret: selectedIntegration.secret,
      tenantRef: selectedIntegration.tenantRef || undefined,
      tenantEndpoint: selectedIntegration.tenantEndpoint || undefined,
    })
    if (result.success) {
      setSelectedIntegration({ type: '', secret: '', tenantRef: '', tenantEndpoint: '' })
    }
  }

  const selectedType = integrationTypes?.find((type) => type.type === selectedIntegration.type)
  const requiresTenantRef = !!selectedType?.requires_tenant_ref
  const allowsTenantEndpoint = !!selectedType?.allows_tenant_endpoint
  const tenantRefName = selectedType?.tenant_ref_name || ''

  const isValidTenantEndpoint = (val) => !val || constants.URL_VALIDATION_REGEX.test(val.trim())

  // return
  return (
    <>
      <div className="integrations_add">
        <div className="integrations_add__row">
          <DropDown
            classNames="integrations_add__dropdown"
            options={options}
            placeholder={t('Integrations.manage.integration')}
            onChange={(t) => setSelectedIntegration((v) => ({ ...v, type: t }))}
            value={selectedIntegration.type}
            name="integrationType"
            disabled={!integrationTypes}
          />

          <Input
            value={selectedIntegration.secret}
            name="key"
            required
            placeholder={t('Integrations.manage.addApiKey')}
            separatePlaceholder
            onChange={(e) => setSelectedIntegration((si) => ({ ...si, secret: e.target.value }))}
            wrapperClass="integrations_add__input"
            disabled={!selectedIntegration.type}
          />

          {requiresTenantRef && (
            <Input
              value={selectedIntegration.tenantRef}
              name="tenant_ref"
              required
              placeholder={t(`Integrations.manage.${tenantRefName}`)}
              separatePlaceholder
              onChange={(e) => setSelectedIntegration((si) => ({ ...si, tenantRef: e.target.value }))}
              wrapperClass="integrations_add__input"
            />
          )}

          {!allowsTenantEndpoint && (
            <SecondaryButton
              color="orange"
              text={t('common.save')}
              classNames="integrations_add__button"
              onClick={submitIntegration}
              fullWidth={false}
              disabled={
                !selectedIntegration.type ||
                !selectedIntegration.secret ||
                (requiresTenantRef && !selectedIntegration.tenantRef) ||
                loading.add
              }
            />
          )}
        </div>

        {allowsTenantEndpoint && (
          <div className="integrations_add__row integrations_add__row--endpoint">
            <Input
              value={selectedIntegration.tenantEndpoint}
              name="tenant_endpoint"
              required={false}
              placeholder={t('Integrations.manage.tenant_endpoint')}
              separatePlaceholder
              onChange={(e) =>
                setSelectedIntegration((si) => ({ ...si, tenantEndpoint: e.target.value }))
              }
              wrapperClass="integrations_add__input"
              validator={(val) => ({
                isValid: isValidTenantEndpoint(val),
                errorMsg: t('Integrations.manage.errors.invalidTenantEndpoint'),
              })}
              validateOnBlur
              errorBelow
            />

            <SecondaryButton
              color="orange"
              text={t('common.save')}
              classNames="integrations_add__button"
              onClick={submitIntegration}
              fullWidth={false}
              disabled={
                !selectedIntegration.type ||
                !selectedIntegration.secret ||
                (requiresTenantRef && !selectedIntegration.tenantRef) ||
                !isValidTenantEndpoint(selectedIntegration.tenantEndpoint) ||
                loading.add
              }
            />
          </div>
        )}
      </div>
      {error.add && (
        <ErrorMessage classNames="mt-2" danger>
          {error.add}
        </ErrorMessage>
      )}
    </>
  )
}
